export let ExperimentKeys;

(function (ExperimentKeys) {
  ExperimentKeys["ACQ0134"] = "acq01-acq-0134";
  ExperimentKeys["ONBU0025"] = "onbu-0025";
  ExperimentKeys["CSFE0014"] = "csfe-0014";
  ExperimentKeys["ACQ0140"] = "acq-0140";
})(ExperimentKeys || (ExperimentKeys = {}));

export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';